import { getCompanyImage } from '../../../common/styles/Images';
import { formatDesignationDisplay, getDomainValueForCode, isEmpty } from '../../../library/Core/SmartFunctions';
import { jobPlace, pickDisplayJob } from '../../../library/Service/currentJobDisplay';

const CardHomeMaker = ({ alumni, state }: { alumni: any;  state: any }) => {
    let subjectDiv = null;
    let practiceName = '';
    let practiceLogo = alumni?.jobCompanyImage;
    let practiceCount = 0;

    if (alumni?.workingStatusCode === 'HOME_MAKER') {
        if (!isEmpty(alumni?.homeMakerStartYear)) {
            if (alumni?.homeMakerStartYear !== 0) {
                subjectDiv = (
                    <div className="alumni_university_subject">
                        <i className=""></i>
                        <span>Since {alumni?.homeMakerStartYear}</span>
                    </div>
                );
            }
        }
    } else {
        const lookup = (id: any, domain: string) => getDomainValueForCode(id, domain, state);
        const { job, count } = pickDisplayJob(alumni?.currentJobsJson, undefined, alumni?.workingStatusCode);
        practiceCount = count;
        const place = job ? jobPlace(job, lookup) : null;
        practiceName =
            place?.name ||
            (alumni?.jobCompanyId ? getDomainValueForCode(alumni.jobCompanyId, 'COMPANY_CODE', state) : alumni?.companyName) ||
            '';
        practiceLogo = place?.logo || alumni?.jobCompanyImage;
        const designation = formatDesignationDisplay(job?.designation || alumni?.designation, state, {
            workingStatusCode: job?.jobCategory || 'PROFESSIONAL_PRACTICE',
        });
        const practiceCode = (job as { typeOfPractice?: string } | null)?.typeOfPractice || alumni?.typeOfPractice;
        const resolvedPractice = practiceCode ? getDomainValueForCode(practiceCode, 'PROFESSIONAL_PRACTICE_TYPE', state) : '';
        const practiceLabel =
            resolvedPractice && String(resolvedPractice) !== String(practiceCode)
                ? resolvedPractice
                : practiceCode
                ? String(practiceCode).replace(/_/g, ' ')
                : '';
        const role = designation || practiceLabel;
        subjectDiv = role ? (
            <div className="alumni_univarsity_subject">
                <i className="icon-brifecase"></i>
                <span>{role}</span>
            </div>
        ) : null;
    }

    return (
        <div key={alumni.uuid} className="alumni_univarsity_details working">
            <div className="alumni_univarsity_details_inner_cover">
                <div className="alumni_univarsity_logo">
                    {/* <img src={`${process.env.REACT_APP_IMAGE_BASEPATH}/dummy_male.svg`} alt="" /> */}
                    <img src={(alumni?.workingStatusCode !== 'HOME_MAKER') ? getCompanyImage(practiceLogo || '') : 'https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/home-icon-directory.svg'} alt="" />
                </div>
                <div className="alumni_univarsity_brife">
                    <div className="alumni_education">
                        <div className="row g-2">
                            <div className="col d-flex align-items-center flex-nowrap">
                                <span>{(alumni?.workingStatusCode === 'HOME_MAKER') ? 'Working as' : 'Professional Practice'}</span>
                                {alumni?.workingStatusCode !== 'HOME_MAKER' && practiceCount > 1 && (
                                    <span className="current-roles-count">{practiceCount} current roles</span>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="alumni_univarsity_name">
                        <span>{(alumni?.workingStatusCode === 'HOME_MAKER') ? 'Homemaker' : practiceName}</span>
                    </div>
                    {subjectDiv}
                </div>
            </div>
        </div>
    );
};

export default CardHomeMaker;
